import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const useScrollToTop = () => {
  const navigate = useNavigate()

  useEffect(() => {
    // 페이지 이동시 스크롤 항상 맨 위
    window.scrollTo(0, 0)
  }, [navigate])
}
